import * as Types from '../constants/actionTypes';
const defaultState = {
    isPending: false,
    pbiReports: [],
    accesses: [],
    error: ''
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case Types.PBI_DATA:
            return {
                ...state,
                pbiReports: action.data
            }
        case Types.PBI_DATA_COUNT:
            return Object.assign({}, state, { reportsCount: action.data })
        case Types.PBI_DATA_ADDED:
            const idx1 = state.pbiReports.findIndex((data) => { return data.id === action.data.id });
            if (idx1 > -1) {
                state.pbiReports[idx1] = action.data
            } else {
                state.pbiReports.push(action.data)
            }
            return {
                ...state,
            }
        case Types.PBI_DATA_DELETED:
            const reps = state.pbiReports.filter((f) => f.id !== action.data)
            return {
                ...state,
                pbiReports: reps,
                deletedStatus: action.data
            }
        case Types.PBI_ERROR:
            return {
                ...state,
                messageErr: action.message
            }
        case Types.PBI_ACCESS_DATA:
            return {
                ...state,
                accesses: action.data
            }
        case Types.PBI_ACCESS_DATA_ADDED:
            const idx2 = state.accesses.findIndex((data) => { return data.id === action.data.id });
            if (idx2 > -1) {
                state.accesses[idx2] = action.data
            } else {
                state.accesses.push(action.data)
            }
            return {
                ...state,
            }
        case Types.PBI_ACCESS_DATA_DELETED:
            const newList = state.accesses.filter((f) => f.id !== action.data)
            return {
                ...state,
                accesses: newList,
                deletedStatus: action.data
            }
        case Types.PBI_REPORTS_USER_SET:
            return {
                ...state,
                userReport: action.data
            }
        case Types.PBI_REPORTS_ADMIN_USER_SET:
            return {
                    ...state,
                    adminUserReport: action.data
            }
        default:
            return state
    }
}
